import React from "react";
import PropTypes from "prop-types";

import useClientCardIframeSync from "./hooks/useClientCardIframeSync";
import useClientCardIframeSyncOptions from "./hooks/useClientCardIframeSyncOptions";

export default function ClientCard({
  mapPathnameForIframeSrc,
  mapPathnameFromChild,
  syncEnabled,
  sessionCommand,
}) {
  const syncOptions = useClientCardIframeSyncOptions({
    mapPathnameForIframeSrc,
    mapPathnameFromChild,
    syncEnabled,
    sessionCommand,
  });

  const { iframeRef, iframeSrc, handleIframeLoad } =
    useClientCardIframeSync(syncOptions);

  return (
    <iframe
      ref={iframeRef}
      id="new-client-card-iframe"
      src={iframeSrc}
      title="New Client Card Content"
      style={{ border: "none", width: "100%", height: "100%" }}
      onLoad={handleIframeLoad}
    />
  );
}

ClientCard.propTypes = {
  mapPathnameForIframeSrc: PropTypes.func,
  mapPathnameFromChild: PropTypes.func,
  syncEnabled: PropTypes.bool,
  sessionCommand: PropTypes.shape({
    id: PropTypes.number.isRequired,
    command: PropTypes.string.isRequired,
  }),
};

ClientCard.defaultProps = {
  mapPathnameForIframeSrc: undefined,
  mapPathnameFromChild: undefined,
  syncEnabled: undefined,
  sessionCommand: undefined,
};
